import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <main className="contact">
      <div className="contact-container">
        <h1 className="contact-title">Contact Us</h1>
        <p className="contact-subtitle">Get in touch with EJ Business & Co</p>
        
        <div className="contact-info">
          <div className="contact-item">
            <h2 className="contact-label">Email</h2>
            <a href="mailto:ejbusiness2236@gmail.com" className="contact-link">
              ejbusiness2236@gmail.com
            </a>
          </div>
          
          <div className="contact-item">
            <h2 className="contact-label">Phone</h2>
            <a href="tel:8482100956" className="contact-link">
              (848) 210-0956
            </a>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Contact;

